export const parseUsernames = (text: string): string[] =>
  text.split(/[\n,;]/).filter((username) => username.length > 0);
